import { useEffect, useState } from 'react';

/**
 * Affichage progressif du texte caractère par caractère.
 * @param {string} fullText - le texte complet à afficher
 * @param {number} speedMs - délai entre chaque char (défaut 30ms)
 * @returns {{displayed: string, done: boolean, skip: () => void}}
 */
export default function useTypewriter(fullText, speedMs = 30) {
  const [displayed, setDisplayed] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    setDisplayed('');
    setDone(false);
    if (!fullText) { setDone(true); return; }

    let i = 0;
    let cancelled = false;
    const interval = setInterval(() => {
      if (cancelled) return;
      i++;
      setDisplayed(fullText.slice(0, i));
      if (i >= fullText.length) {
        clearInterval(interval);
        setDone(true);
      }
    }, speedMs);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [fullText, speedMs]);

  const skip = () => {
    setDisplayed(fullText || '');
    setDone(true);
  };

  return { displayed, done, skip };
}
